import { FaLockOpen } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const MobileForbiddenModule = ({ viewType }) => {
  const { t } = useTranslation();

  const title =
    viewType === "monitoring"
      ? t("Save 30% on your waste management costs")
      : viewType === "photoCapture"
        ? t("Capture waste photos from your mobile")
        : t(
            "Generate regulatory characterization reports complying with AGEC Decree 1199",
          );

  const subtitle =
    viewType === "monitoring"
      ? t(
          "Improve the quality of your waste streams by reducing sorting errors by 20%",
        )
      : viewType === "photoCapture"
        ? t("Take photos on site and send them for automatic analysis")
        : t(
            "Get your characterization reports at 80% less cost than traditional methods",
          );

  return (
    <div className="installation-subpage-card mobile-forbidden-card">
      <div className="mobile-forbidden-icon" aria-hidden>
        <FaLockOpen />
      </div>
      <h2 className="mobile-forbidden-title">{title}</h2>
      <p className="mobile-forbidden-subtitle">{subtitle}</p>
      <p className="mobile-forbidden-contact">
        {t("Contact us at")}{" "}
        <a href="mailto:client@akanthas.com" className="mobile-forbidden-email">
          client@akanthas.com
        </a>{" "}
        {t("for more information")}.
      </p>
    </div>
  );
};

export default MobileForbiddenModule;
